/**
 * TypeScript view of the `peg_solitaire` format.
 * Source of truth: `shared/schema/peg_solitaire.{definition,submission,solution,progress}.json`.
 */

export type Localized = Record<string, string | undefined>;

export const NO_HOLE = " ";
export const PEG = "o";
export const EMPTY = ".";

/** One jump: `[fromRow, fromCol, toRow, toCol]`. */
export type Move = [number, number, number, number];
export type Cell = [row: number, col: number];

export interface PegSolitaireDefinition {
  puzzleType: "peg_solitaire";
  typeVersion: number;
  /** One string per row, all the same length: `" "` no hole, `"o"` a peg, `"."` an empty hole. */
  board: string[];
  /** Public: the hole the last peg must end in. Absent or null means anywhere. */
  target?: Cell | null;
  rulesText?: Localized;
  meta?: Record<string, unknown>;
}

/** Autosave shape. Opaque to the core; this type owns it and its migrations. */
export interface PegSolitaireProgress {
  version: 1;
  /** The jumps so far. Replaying them from the board gives the position. */
  moves: Move[];
  /** The tail taken back, still redoable. Never sent to the server. */
  undone?: Move[];
}

export interface PegSolitaireSubmission {
  moves: Move[];
}

/** The author's reference sequence, in the submission format. */
export type PegSolitaireSolution = PegSolitaireSubmission;

export const MIN_SIZE = 3;
export const MAX_SIZE = 9;
export const MAX_MOVES = 200;

export function cellId(row: number, col: number): string {
  return `r${row}c${col}`;
}
